class UploadButtonsToggle {
	constructor(container) {
		const seeMoreBtn = container.querySelector('.form-components__see-more-uploads');
		const uploadButtons = container.querySelectorAll('.ktc-file-component-wrapper');
		if (uploadButtons.length === 0 || !seeMoreBtn) return;
		this.uploadBtnsToHide = [].slice.call(uploadButtons).slice(1);		
		this.additionalUploadsHide(seeMoreBtn);
		seeMoreBtn.addEventListener('click', this.toggleUploads.bind(this, seeMoreBtn));
	}

	additionalUploadsHide(btn) {
		this.uploadBtnsToHide.forEach((el) => {
			el.classList.add('hidden');
		});

		if (this.uploadBtnsToHide.length === 0) btn.classList.add('hidden');
	}

	toggleUploads(btn) {
		btn.classList.toggle('active');
		if (btn.classList.contains('active')) {
			btn.innerText = btn.dataset.close;
			btn.setAttribute("aria-expanded", "true");
		} else {
			btn.innerText = btn.dataset.open;
			btn.setAttribute("aria-expanded", "false");
		}
		
		this.uploadBtnsToHide.forEach((el) => {
			el.classList.toggle('hidden');
		});
	}
}

export default UploadButtonsToggle;
